export function getElementWidth(el, margin) {
    const elementMarginRight = margin;

    return el.offsetWidth + parseFloat(elementMarginRight);
}
